export default __webpack_public_path__ + "static/media/shareTunes4Low.66a39fe2.png";